import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ApolloProvider, ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { Toaster } from 'sonner';
import LandingPage from './pages/LandingPage';
import ConferencePage from './pages/conference/ConferencePage';
import './index.css';
import config from './config/config';

const httpLink = createHttpLink({
  uri: config.graphqlUrl,
  credentials: 'include',
});

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: { fetchPolicy: 'network-only', errorPolicy: 'all' },
    query: { fetchPolicy: 'network-only', errorPolicy: 'all' },
    mutate: { errorPolicy: 'all' },
  },
});

const App: React.FC = () => {
  return (
    <ApolloProvider client={client}>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/conference" element={<ConferencePage />} />
          <Route path="*" element={<LandingPage />} />
        </Routes>
      </Router>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: 'var(--color-surface)',
            color: 'var(--color-white)',
            border: '1px solid var(--color-border)',
            borderRadius: 0,
            fontFamily: 'Haffer, sans-serif',
          },
        }}
      />
    </ApolloProvider>
  );
};

export default App;
